"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var reports;
        (function (reports) {
            var preview;
            (function (preview) {
                class InitArgs {
                    constructor() {
                        this.previewUrl = appn.emptyString;
                        this.reportId = appn.emptyString;
                        this.reportType = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTable = null;
                function init(args) {
                    _initArgs = args;
                    renderParameters();
                    addFilterEvents();
                    createDataTable();
                }
                preview.init = init;
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        sAjaxSource: _initArgs.previewUrl || 'Reports/PreviewDataTable',
                        fnServerData: function (data) {
                            data.push({ name: 'sCustom_0', value: _initArgs.reportId }, { name: 'sCustom_1', value: _initArgs.reportType });
                            const paramValues = getParameterValues();
                            let customIndex = 2;
                            paramValues.forEach((param) => {
                                data.push({ name: `sCustom_${customIndex}`, value: param.name });
                                data.push({ name: `sCustom_${customIndex + 1}`, value: param.value });
                                customIndex += 2;
                            });
                        },
                        autoWidth: false,
                        aaSorting: [[1, 'desc']],
                        aoColumns: buildColumns(),
                        fnInitComplete: function () {
                            appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                            appn.dataTable.addSearchPlaceholder(T('Filter preview results...'));
                        }
                    });
                }
                function buildColumns() {
                    const ths = $('.dataTable thead th');
                    const cols = [];
                    ths.each(function (idx) {
                        cols.push({ bSortable: false });
                    });
                    return cols;
                }
                function renderParameters() {
                    const paramsForSelection = getInitialParams();
                    const $container = $('#report-parameters-preview');
                    $container.empty();
                    if (!paramsForSelection || paramsForSelection.length === 0)
                        return;
                    paramsForSelection.forEach((p, idx) => {
                        const inputId = `rp_preview_${idx}`;
                        const label = $('<label/>')
                            .attr('for', inputId)
                            .addClass('px-0 pt-0')
                            .text(p.Name || '');
                        const $row = $('<div/>').addClass('form-group form-row mb-1 mx-0');
                        if (isTextKind(p.Kind)) {
                            const $input = $('<input/>')
                                .attr('type', 'text')
                                .addClass('form-control form-control-sm')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .attr('placeholder', p.PlaceholderText || '')
                                .val(p.Value || '');
                            applyRequiredIfNeeded($input, p);
                            $row.append(label).append($input);
                        }
                        else if (isIntegerKind(p.Kind)) {
                            const $input = $('<input/>')
                                .attr('type', 'number')
                                .attr('step', '1')
                                .addClass('form-control form-control-sm')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .attr('placeholder', p.PlaceholderText || '')
                                .val(p.Value || '');
                            applyRequiredIfNeeded($input, p);
                            $row.append(label).append($input);
                        }
                        else if (isDecimalKind(p.Kind)) {
                            const $input = $('<input/>')
                                .attr('type', 'number')
                                .attr('step', 'any')
                                .addClass('form-control form-control-sm')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .attr('placeholder', p.PlaceholderText || '')
                                .val(p.Value || '');
                            applyRequiredIfNeeded($input, p);
                            $row.append(label).append($input);
                        }
                        else if (isBooleanKind(p.Kind)) {
                            const $row = $('<div/>').addClass('form-group form-row mb-1 mx-0');
                            const inputId = `rp_preview_${idx}`;
                            const $hiddenFalse = $('<input/>')
                                .attr('type', 'hidden')
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .val('false');
                            const $checkbox = $('<input/>')
                                .attr('type', 'checkbox')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .val('true')
                                .prop('checked', p.Value === 'true');
                            const $wrapper = $('<div/>')
                                .addClass('icheck-primary')
                                .addClass('appn-checkbox');
                            const $checkLabel = $('<label/>').attr('for', inputId).text(p.Name || '');
                            $wrapper.append($checkbox).append($checkLabel);
                            $row.append($hiddenFalse).append($wrapper);
                            $container.append($row);
                        }
                        else if (isDateKind(p.Kind)) {
                            const $group = $('<div/>').addClass('input-group date datetimepicker');
                            const $input = $('<input/>')
                                .attr('type', 'text')
                                .addClass('form-control form-control-sm')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .attr('placeholder', p.PlaceholderText || '')
                                .val(p.Value || '');
                            applyRequiredIfNeeded($input, p);
                            const $icon = $('<i/>').addClass('fa fa-calendar fa-xs');
                            const $btn = $('<button/>').attr('type', 'button').addClass('input-group-text btn btn-secondary').append($icon);
                            const $append = $('<div/>').addClass('input-group-append input-group-addon').append($btn);
                            $group.append($input).append($append);
                            $row.append(label).append($group);
                            setTimeout(() => {
                                try {
                                    if (appn.ui && appn.ui.datePicker) {
                                        appn.ui.datePicker($group);
                                    }
                                }
                                catch (e) {
                                    console.log('DatePicker initialization failed:', e);
                                }
                            }, 100);
                        }
                        else if (isDateTimeKind(p.Kind)) {
                            const $group = $('<div/>').addClass('input-group date datetimepicker');
                            const $input = $('<input/>')
                                .attr('type', 'text')
                                .addClass('form-control form-control-sm')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .attr('placeholder', p.PlaceholderText || '')
                                .val(p.Value || '');
                            applyRequiredIfNeeded($input, p);
                            const $icon = $('<i/>').addClass('fa fa-calendar fa-xs');
                            const $btn = $('<button/>').attr('type', 'button').addClass('input-group-text btn btn-secondary').append($icon);
                            const $append = $('<div/>').addClass('input-group-append input-group-addon').append($btn);
                            $group.append($input).append($append);
                            $row.append(label).append($group);
                            setTimeout(() => {
                                try {
                                    if (appn.ui && appn.ui.dateTimePicker) {
                                        appn.ui.dateTimePicker($group);
                                    }
                                }
                                catch (e) {
                                    console.log('DateTimePicker initialization failed:', e);
                                }
                            }, 100);
                        }
                        else if (isTimeKind(p.Kind)) {
                            const $group = $('<div/>').addClass('input-group timepicker');
                            const $input = $('<input/>')
                                .attr('type', 'text')
                                .addClass('form-control form-control-sm')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .attr('placeholder', p.PlaceholderText || '')
                                .val(p.Value || '');
                            applyRequiredIfNeeded($input, p);
                            const $icon = $('<i/>').addClass('fa fa-clock fa-xs');
                            const $btn = $('<button/>').attr('type', 'button').addClass('input-group-text btn btn-secondary').append($icon);
                            const $append = $('<div/>').addClass('input-group-append input-group-addon').append($btn);
                            $group.append($input).append($append);
                            $row.append(label).append($group);
                            setTimeout(() => {
                                try {
                                    if (appn.ui && appn.ui.timePicker) {
                                        appn.ui.timePicker($group);
                                    }
                                }
                                catch (e) {
                                    console.log('TimePicker initialization failed:', e);
                                }
                            }, 100);
                        }
                        else if (isDateRangeKind(p.Kind)) {
                            let dateRangeData = {};
                            try {
                                if (p.Value) {
                                    dateRangeData = JSON.parse(p.Value);
                                }
                            }
                            catch (e) {
                                dateRangeData = { RangeType: 'ThisMonth', FromDate: null, ToDate: null };
                            }
                            const $select = $('<select/>')
                                .attr('id', inputId + '_select')
                                .addClass('form-control form-control-sm appn-daterange-select')
                                .attr('data-param-index', idx);
                            const rangeOptions = [
                                { value: 'All', text: 'All' },
                                { value: 'Today', text: 'Today' },
                                { value: 'Last7Days', text: 'Last 7 Days' },
                                { value: 'ThisMonth', text: 'This Month' },
                                { value: 'LastMonth', text: 'Last Month' },
                                { value: 'Last6Months', text: 'Last 6 Months' },
                                { value: 'Last12Months', text: 'Last 12 Months' },
                                { value: 'CustomRange', text: 'Custom Range' }
                            ];
                            rangeOptions.forEach(option => {
                                const $option = $('<option/>')
                                    .attr('value', option.value)
                                    .text(option.text);
                                if (dateRangeData.RangeType === option.value) {
                                    $option.attr('selected', 'selected');
                                }
                                $select.append($option);
                            });
                            const $customContainer = $('<div/>')
                                .addClass('container-custom-filter container-fluid mb-3 mt-2 px-0')
                                .attr('id', inputId + '_custom')
                                .css('display', dateRangeData.RangeType === 'CustomRange' ? 'block' : 'none');
                            const $fromGroup = $('<div/>').addClass('input-group date datepicker mb-2');
                            const $fromInput = $('<input/>')
                                .attr('type', 'text')
                                .addClass('form-control form-control-sm')
                                .attr('id', inputId + '_from')
                                .attr('placeholder', 'From Date')
                                .val(dateRangeData.FromDate || '');
                            const $fromIcon = $('<i/>').addClass('fa fa-calendar fa-xs');
                            const $fromBtn = $('<button/>').attr('type', 'button').addClass('input-group-text btn btn-secondary').append($fromIcon);
                            const $fromAppend = $('<div/>').addClass('input-group-append input-group-addon').append($fromBtn);
                            $fromGroup.append($fromInput).append($fromAppend);
                            const $toGroup = $('<div/>').addClass('input-group date datepicker');
                            const $toInput = $('<input/>')
                                .attr('type', 'text')
                                .addClass('form-control form-control-sm')
                                .attr('id', inputId + '_to')
                                .attr('placeholder', 'To Date')
                                .val(dateRangeData.ToDate || '');
                            const $toIcon = $('<i/>').addClass('fa fa-calendar fa-xs');
                            const $toBtn = $('<button/>').attr('type', 'button').addClass('input-group-text btn btn-secondary').append($toIcon);
                            const $toAppend = $('<div/>').addClass('input-group-append input-group-addon').append($toBtn);
                            $toGroup.append($toInput).append($toAppend);
                            $customContainer.append($fromGroup).append($toGroup);
                            const $hiddenValue = $('<input/>')
                                .attr('type', 'hidden')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .val(p.Value || '');
                            $row.append(label).append($select).append($customContainer).append($hiddenValue);
                            $select.on('change', function () {
                                const selectedRange = $(this).val();
                                const $custom = $(`#${inputId}_custom`);
                                const $hidden = $(`#${inputId}`);
                                if (selectedRange === 'CustomRange') {
                                    $custom.show();
                                }
                                else {
                                    $custom.hide();
                                    const rangeData = {
                                        RangeType: selectedRange,
                                        FromDate: null,
                                        ToDate: null
                                    };
                                    $hidden.val(JSON.stringify(rangeData));
                                }
                            });
                            $fromInput.add($toInput).on('change', function () {
                                const fromDate = $(`#${inputId}_from`).val();
                                const toDate = $(`#${inputId}_to`).val();
                                const $hidden = $(`#${inputId}`);
                                const rangeData = {
                                    RangeType: 'CustomRange',
                                    FromDate: fromDate,
                                    ToDate: toDate
                                };
                                $hidden.val(JSON.stringify(rangeData));
                            });
                            setTimeout(() => {
                                try {
                                    if (appn.ui && appn.ui.datePicker) {
                                        appn.ui.datePicker($fromGroup);
                                        appn.ui.datePicker($toGroup);
                                    }
                                }
                                catch (e) {
                                    console.log('DateRange DatePicker initialization failed:', e);
                                }
                            }, 100);
                            applyRequiredIfNeeded($hiddenValue, p);
                        }
                        else if (isSelectKind(p.Kind)) {
                            const $select = $('<select/>')
                                .addClass('form-control form-control-sm select2-noinit')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`);
                            if (p.IsOptional) {
                                const $placeholderOption = $('<option/>')
                                    .attr('value', '')
                                    .text(p.PlaceholderText || 'Select an option...');
                                $select.append($placeholderOption);
                            }
                            if (p.Options && Object.keys(p.Options).length > 0) {
                                Object.keys(p.Options).forEach(optionKey => {
                                    const displayText = p.Options[optionKey];
                                    const $option = $('<option/>')
                                        .attr('value', optionKey)
                                        .text(displayText);
                                    if (p.Value === optionKey) {
                                        $option.attr('selected', 'selected');
                                    }
                                    $select.append($option);
                                });
                            }
                            applyRequiredIfNeeded($select, p);
                            $row.append(label).append($select);
                            setTimeout(() => {
                                try {
                                    if ($select.select2) {
                                        $select.select2({
                                            theme: 'bootstrap4',
                                            allowClear: p.IsOptional,
                                            placeholder: p.PlaceholderText || 'Select an option...'
                                        });
                                    }
                                }
                                catch (e) {
                                    console.log('Select2 initialization failed:', e);
                                }
                            }, 100);
                        }
                        else if (isMultiSelectKind(p.Kind)) {
                            const $select = $('<select/>')
                                .addClass('form-control form-control-sm select2-noinit')
                                .attr('id', inputId)
                                .attr('name', `ReportParameters[${idx}].Value`)
                                .attr('multiple', 'multiple');
                            let selectedValues = [];
                            try {
                                if (p.Value) {
                                    selectedValues = JSON.parse(p.Value);
                                    if (!Array.isArray(selectedValues)) {
                                        selectedValues = [];
                                    }
                                }
                            }
                            catch (e) {
                                selectedValues = [];
                            }
                            if (p.Options && Object.keys(p.Options).length > 0) {
                                Object.keys(p.Options).forEach(optionKey => {
                                    const displayText = p.Options[optionKey];
                                    const $option = $('<option/>')
                                        .attr('value', optionKey)
                                        .text(displayText);
                                    if (selectedValues.includes(optionKey)) {
                                        $option.attr('selected', 'selected');
                                    }
                                    $select.append($option);
                                });
                            }
                            applyRequiredIfNeeded($select, p);
                            $row.append(label).append($select);
                            setTimeout(() => {
                                try {
                                    if ($select.select2) {
                                        $select.select2({
                                            theme: 'bootstrap4',
                                            allowClear: p.IsOptional,
                                            placeholder: p.PlaceholderText || 'Select options...',
                                            multiple: true
                                        });
                                    }
                                }
                                catch (e) {
                                    console.log('MultiSelect Select2 initialization failed:', e);
                                }
                            }, 100);
                        }
                        const kindName = toEnumName(p.Kind);
                        const $hiddenKind = $('<input/>')
                            .attr('type', 'hidden')
                            .attr('name', `ReportParameters[${idx}].Kind`)
                            .val(kindName);
                        $row.append($hiddenKind);
                        $container.append($row);
                    });
                }
                function addFilterEvents() {
                    $(document).on('click', '#apply-filters-btn', function () {
                        refreshDataTable();
                    });
                    $(document).on('click', '#export-preview-btn', function () {
                        exportPreviewData();
                    });
                }
                function refreshDataTable() {
                    if (_dataTable) {
                        _dataTable.fnDraw();
                    }
                }
                function exportPreviewData() {
                    const $form = $('<form/>')
                        .attr('method', 'POST')
                        .attr('action', 'ExportPreviewData')
                        .css('display', 'none');
                    $form.append($('<input/>').attr('type', 'hidden').attr('name', 'Id').val(_initArgs.reportId));
                    $form.append($('<input/>').attr('type', 'hidden').attr('name', 'Type').val(_initArgs.reportType));
                    const paramValues = getParameterValues();
                    paramValues.forEach((param) => {
                        $form.append($('<input/>')
                            .attr('type', 'hidden')
                            .attr('name', `Parameters[${param.name}]`)
                            .val(param.value));
                    });
                    $('body').append($form);
                    $form.submit();
                    $form.remove();
                }
                function getParameterValues() {
                    const params = [];
                    const paramsForSelection = getInitialParams();
                    $('#report-parameters-preview input[name*=".Value"], #report-parameters-preview select[name*=".Value"]').each(function () {
                        var _a;
                        const $this = $(this);
                        if ($this.attr('type') === 'hidden') {
                            const $nextCheckboxWrapper = $this.next('.icheck-primary');
                            if ($nextCheckboxWrapper.length > 0 && $nextCheckboxWrapper.find('input[type="checkbox"]').attr('name') === $this.attr('name')) {
                                return;
                            }
                        }
                        const name = $this.attr('name') || '';
                        let value;
                        if ($this.attr('type') === 'checkbox') {
                            value = $this.prop('checked').toString();
                        }
                        else if ($this.attr('type') === 'hidden') {
                            const indexMatch = name.match(/\[(\d+)\]/);
                            if (indexMatch) {
                                const paramIndex = parseInt(indexMatch[1]);
                                const param = paramsForSelection[paramIndex];
                                if (param && isDateRangeKind(param.Kind)) {
                                    const inputId = `rp_preview_${paramIndex}`;
                                    const selectedRange = $(`#${inputId}_select`).val();
                                    const fromDate = $(`#${inputId}_from`).val();
                                    const toDate = $(`#${inputId}_to`).val();
                                    value = JSON.stringify({
                                        RangeType: selectedRange,
                                        FromDate: fromDate,
                                        ToDate: toDate
                                    });
                                    $this.val(value);
                                }
                                else {
                                    value = $this.val();
                                }
                            }
                        }
                        else {
                            const indexMatch = name.match(/\[(\d+)\]/);
                            if (indexMatch) {
                                const paramIndex = parseInt(indexMatch[1]);
                                const param = paramsForSelection[paramIndex];
                                if (param && isMultiSelectKind(param.Kind)) {
                                    const selectedValues = $this.val() || [];
                                    value = JSON.stringify(selectedValues);
                                }
                                else {
                                    value = $this.val();
                                }
                            }
                            else {
                                value = $this.val();
                            }
                        }
                        if (name.includes('.Value')) {
                            const indexMatch = name.match(/\[(\d+)\]/);
                            if (indexMatch) {
                                const paramIndex = parseInt(indexMatch[1]);
                                const paramName = ((_a = paramsForSelection[paramIndex]) === null || _a === void 0 ? void 0 : _a.Name) || `param_${paramIndex}`;
                                params.push({ name: paramName, value: value });
                            }
                        }
                    });
                    return params;
                }
                function getInitialParams() {
                    const $hidden = $('#report-params-preview');
                    if ($hidden.length === 0)
                        return [];
                    const val = $hidden.val() || '';
                    if (!val || !val.trim())
                        return [];
                    try {
                        return JSON.parse(val);
                    }
                    catch (e) {
                        return [];
                    }
                }
                function applyRequiredIfNeeded($el, p) {
                    if (!p || !p.IsOptional) {
                        $el.attr('required', 'required').attr('aria-required', 'true');
                    }
                }
                function isTextKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 0;
                    if (!kind)
                        return false;
                    return kind.toLowerCase() === 'text';
                }
                function isIntegerKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 1;
                    if (!kind)
                        return false;
                    return kind.toLowerCase() === 'integer' || kind.toLowerCase() === 'int';
                }
                function isDecimalKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 2;
                    if (!kind)
                        return false;
                    const k = kind.toLowerCase();
                    return k === 'decimal' || k === 'number' || k === 'float' || k === 'double';
                }
                function isBooleanKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 3;
                    if (!kind)
                        return false;
                    const k = kind.toLowerCase();
                    return k === 'boolean' || k === 'bool';
                }
                function isDateKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 4;
                    if (!kind)
                        return false;
                    return kind.toLowerCase() === 'date';
                }
                function isDateRangeKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 5;
                    if (!kind)
                        return false;
                    return kind.toLowerCase() === 'daterange';
                }
                function isTimeKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 6;
                    if (!kind)
                        return false;
                    return kind.toLowerCase() === 'time';
                }
                function isDateTimeKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 7;
                    if (!kind)
                        return false;
                    return kind.toLowerCase() === 'datetime';
                }
                function isSelectKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 8;
                    if (!kind)
                        return false;
                    return kind.toLowerCase() === 'select';
                }
                function isMultiSelectKind(kind) {
                    if (typeof kind === 'number')
                        return kind === 9;
                    if (!kind)
                        return false;
                    return kind.toLowerCase() === 'multiselect' || kind.toLowerCase() === 'multi-select';
                }
                function toEnumName(kind) {
                    var _a;
                    if (typeof kind === 'string') {
                        const k = kind.trim();
                        const l = k.toLowerCase();
                        if (l === 'datetime')
                            return 'DateTime';
                        if (l === 'daterange')
                            return 'DateRange';
                        if (l === 'multiselect' || l === 'multi-select')
                            return 'MultiSelect';
                        if (l === 'number' || l === 'float' || l === 'double')
                            return 'Decimal';
                        if (l === 'bool')
                            return 'Boolean';
                        return k.charAt(0).toUpperCase() + k.slice(1);
                    }
                    const map = ['Text', 'Integer', 'Decimal', 'Boolean', 'Date', 'DateRange', 'Time', 'DateTime', 'Select', 'MultiSelect'];
                    return (_a = map[kind]) !== null && _a !== void 0 ? _a : 'Text';
                }
            })(preview = reports.preview || (reports.preview = {}));
        })(reports = views.reports || (views.reports = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
